module.exports = __webpack_public_path__ + "static/media/me.9c22ce4c.GIF";